import script from "./BuyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyPage.vue?vue&type=script&setup=true&lang=js"

import "./BuyPage.vue?vue&type=style&index=0&id=19e0f40a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e0f40a"]])

export default __exports__